import React, { useMemo, PropsWithChildren } from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { useODSessionContext } from '@/hooks/useODSessionContext'
import { ConfigStore } from '@/stores/config'

export const ThemeProvider = ({ children }: PropsWithChildren<object>) => {
  const { ui } = ConfigStore.getState()

  const { entry } = useODSessionContext()

  const isHpx = useMemo(() => ui === 'hpx', [ui])

  const isSmallville = useMemo(() => entry === 'earlyOobe', [entry])

  return (
    <StyledThemeProvider theme={{ isHpx, isSmallville }}>
      {children}
    </StyledThemeProvider>
  )
}
